'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: flex-start;\n  cursor: pointer;\n  white-space: nowrap;\n  position: relative;\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  cursor: pointer;\n  white-space: nowrap;\n  position: relative;\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _LinkBox = require('../../molecules/LinkBox');
var _LinkBox2 = _interopRequireDefault(_LinkBox);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var MyLinkBox = (0, _styledComponents2.default)(_LinkBox2.default)(_templateObject);
exports.default = MyLinkBox;